import { createSvgIcon } from '@mui/material/utils';

const ConstantGraph = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="35"
    viewBox="0 0 34 35"
    fill="none"
  >
    <path
      d="M7 15.6206C7 15.0683 7.44772 14.6206 8 14.6206H12C12.5523 14.6206 13 15.0683 13 15.6206V29.6206C13 30.1729 12.5523 30.6206 12 30.6206H8C7.44772 30.6206 7 30.1729 7 29.6206V15.6206Z"
      fill="white"
    />
    <path
      d="M14 15.6206C14 15.0683 14.4477 14.6206 15 14.6206H19C19.5523 14.6206 20 15.0683 20 15.6206V29.6206C20 30.1729 19.5523 30.6206 19 30.6206H15C14.4477 30.6206 14 30.1729 14 29.6206V15.6206Z"
      fill="white"
    />
    <path
      d="M26 7.62061C26.5523 7.62061 27 8.06833 27 8.62061C27 9.1729 26.5523 9.62061 26 9.62061L8 9.62061C7.44772 9.62061 7 9.17289 7 8.62061C7 8.06833 7.44772 7.62061 8 7.62061L26 7.62061Z"
      fill="white"
    />
    <path
      d="M26.8318 7.89329C27.2987 8.18826 27.4381 8.80589 27.1432 9.2728C26.8482 9.73972 26.2306 9.87912 25.7636 9.58415L19.8456 5.84556C19.3787 5.55059 19.2393 4.93296 19.5343 4.46604C19.8292 3.99913 20.4469 3.85973 20.9138 4.1547L26.8318 7.89329Z"
      fill="white"
    />
    <path
      d="M19.8454 11.8933C19.3785 12.1883 19.2391 12.8059 19.5341 13.2728C19.8291 13.7397 20.4467 13.8791 20.9136 13.5842L26.8316 9.84556C27.2985 9.55059 27.4379 8.93296 27.143 8.46604C26.848 7.99913 26.2304 7.85973 25.7634 8.1547L19.8454 11.8933Z"
      fill="white"
    />
    <path
      d="M21 15.6206C21 15.0683 21.4477 14.6206 22 14.6206H26C26.5523 14.6206 27 15.0683 27 15.6206V29.6206C27 30.1729 26.5523 30.6206 26 30.6206H22C21.4477 30.6206 21 30.1729 21 29.6206V15.6206Z"
      fill="white"
    />
    <rect x="4" y="29" width="26" height="2" rx="1" fill="white" />
  </svg>,
  'ConstantGraph'
);

export default ConstantGraph;
